__webpack_public_path__ = window.publicPath;  // eslint-disable-line no-undef

import App from 'Components/App.vue';
import appFactory from 'Libs/appFactory';
import { initializeRum } from 'Libs/faro';
import { initCsrf } from 'Libs/helpers/csrf';

const initialState = window.__INITIAL_STATE__;
initializeRum(initialState.environment);
initCsrf(initialState.csrfToken);
const { app } = appFactory(App, initialState);

app.$mount('#app', true);
